// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"ReportsTable_tableWrapper__DXHd2","spinner":"ReportsTable_spinner__3qfS-"};